<template>
  <div class="flex justify-center">
    <p>跳轉中⋯</p>
  </div>
</template>

<script>
import LineCallback from './LineCallback';

export default LineCallback;
</script>

<style lang="scss" scoped>
@import './LineCallback';
</style>
